import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal show",
  tabindex: "-1",
  id: "errorModal",
  "aria-labelledby": "errorModalLabel",
  "aria-hidden": "true",
  style: {"display":"block","background-color":"rgba(0, 0, 0, .65)"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "modal-footer" }



  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TimezoneErrorModal',
  props: {
    message: { type: String }
  },
  emits: ['closeTimezoneErrorModal'],
  setup(__props, { emit: emits }) {

const props = __props;

  

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  

  const closeTimezoneErrorModal = () => {
    emits('closeTimezoneErrorModal');
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (closeTimezoneErrorModal()), ["stop","prevent"]))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", { innerHTML: __props.message }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (closeTimezoneErrorModal()), ["stop","prevent"]))
          }, "閉じる")
        ])
      ])
    ])
  ]))
}
}

})